import AppWithSimulator from './component';

export default AppWithSimulator;
